import { useState } from "react";
import { Translation, Locale } from "../types/GamifiedQuiz.type";
import config from "../../../../config";

export const useTranslations = (entityId: string, GeneralFunctions: any) => {
  const [locales, setLocales] = useState<Locale[]>([]);
  const [translatedData, setTranslatedData] = useState<Translation[]>([]);
  const [translatedHeader, setTranslatedHeader] = useState(
    "Fill out the Details"
  );
  const [translatedButton, setTranslatedButton] = useState("Submit");

  const projectId = config.PHRASE_PROJECT_ID;
  const accessToken = config.PHRASE_ACCESS_TOKEN;

  const fetchLocalesAndTranslations = async () => {
    try {
      const localeResponse = await fetch(
        `https://api.phrase.com/v2/projects/${projectId}/locales`,
        {
          headers: {
            Authorization: `token ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const localesData: Locale[] = await localeResponse.json();
      const filteredLocales = localesData.filter(
        (locale) => locale.id !== "1c7c617229fb6d738a62f213edee028d"
      );

      setLocales(filteredLocales);

      const translationResponses = await Promise.all(
        filteredLocales.map(async (locale) => {
          const queryParams = new URLSearchParams({
            q: `tags:${entityId},static`,
          }).toString();

          const translationResponse = await fetch(
            `https://api.phrase.com/v2/projects/${projectId}/locales/${locale.id}/download?file_format=json&${queryParams}`,
            {
              headers: {
                Authorization: `token ${accessToken}`,
                "Content-Type": "application/json",
              },
            }
          );

          const translations = await translationResponse.json();
          return Object.entries(translations).map(([key, value]) => ({
            key,
            message: (value as { message: string }).message,
            localeId: locale.id,
            name: locale.name,
          }));
        })
      );

      const allTranslations = translationResponses.flat();
      const urlParams = new URLSearchParams(window.location.search);
      const localeCode = urlParams.get("localeCode");

      allTranslations.filter((tr) => {
        if (tr.key === "Fill out the Details" && tr.name === localeCode) {
          setTranslatedHeader(tr.message);
        } else if (tr.key === "Submit" && tr.name === localeCode) {
          setTranslatedButton(tr.message);
        }
      });

      setTranslatedData(allTranslations);
      return allTranslations;
    } catch (error) {
      console.error("Error fetching translations:", error);
      GeneralFunctions.captureSentryException(error);
    }
  };

  return {
    locales,
    translatedData,
    translatedHeader,
    translatedButton,
    fetchLocalesAndTranslations,
  };
};
